import { render, staticRenderFns } from "./SiteRules.vue?vue&type=template&id=0deb5fde"
import script from "./SiteRules.vue?vue&type=script&lang=js"
export * from "./SiteRules.vue?vue&type=script&lang=js"
import style0 from "./SiteRules.vue?vue&type=style&index=0&id=0deb5fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports